/**
 * The roster's six columns, in track order. The tracks themselves live in
 * `RollupRosterMolecule.scss` (MEMBER `minmax(96px, 1.4fr)`, the rest fixed px — never `auto`:
 * header and rows are separate grid elements, so an `auto` track resolves against each row's own
 * content and the columns disagree).
 */
export const ROSTER_COLUMNS = ['member', 'via', 'contrib', 'weight', 'status', 'actions'] as const;

export type RosterColumn = (typeof ROSTER_COLUMNS)[number];
